import React from 'react';
import qs from 'qs';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { RESET_PASSWORD_URL } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';
import Alert from '../../components/generalComponents/Alert';

import styles from './css/ResetPassword.module.css';


const content1 = 'You must enter a username or email address';
const defaultAuthenticityToken =
    'NLcovCIOePYeX3ap6LUfHA/omeBlvqXuFxspVhEz9Fk0aW40ZS/mBzZkPHyXyPIpjA14NZekqSgjJ6NjhKSnmA==';

class ResetPasswordPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      email: '',
      isAlertVisible: false,
      content: '',
    };
  }

  showAlert = (content) => {
    this.setState({
      isAlertVisible: true,
      content,
    });
  };

  hideAlert = () => {
    this.setState({
      isAlertVisible: false,
      content: '',
    });
  };

  handleChange = (name) => (e) => {
    this.setState({ [name]: e.target.value });
  };

  handleSubmit = (e) => {
    const { username, email } = this.state;
    let data = {};
    e.preventDefault();
    if (!(username || email)) {
      // show alert
      return this.showAlert(content1);
    } else if (username) {
      data = { username: username.trim() };
    } else if (email) {
      data = { email: email.trim() };
    }
    callApi(
      RESET_PASSWORD_URL,
      'POST',
      false,
      qs.stringify(data),
      { 'content-type': 'application/x-www-form-urlencoded' }).
      then((res) => {
        if (res.status === 200) {
          localStorage.setItem('resetLinkSent', true);
          this.props.history.push('/account/login');
        }
      }).
      catch((err) => console.log(err));
  };

  render() {
    const { username, email, isAlertVisible, content } = this.state;

    return (
      <div className="content">
        {isAlertVisible && (
          <Alert onClose={this.hideAlert}>{content}</Alert>
        )}
        <div className="container">
          <div className="row-r">
            <div className="col-xs-12 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
              <div className={styles.nakednewsFormContainer}>
                <div className={styles.nakednewsFormTitle}>
                  Recover your account
                </div>
                <div className={styles.nakednewsForm}>
                  <div className={styles.formError} />
                  <div className={styles.nakednewsFormText}>
                    Please enter one of the fields
                  </div>
                  <form
                    acceptCharset="UTF-8"
                    noValidate="novalidate"
                    onSubmit={this.handleSubmit}
                  >
                    <input
                      defaultValue="✓"
                      name="utf8"
                      type="hidden"
                    />
                    <input
                      defaultValue={defaultAuthenticityToken}
                      name="authenticity_token"
                      type="hidden"
                    />
                    <div id="password_username_input">
                      <div className="col-lg-12">
                        <input
                          className={classnames(styles.formInput, styles.username)}
                          id="password_username"
                          name="username"
                          placeholder="Username"
                          type="text"
                          value={username}
                          onChange={this.handleChange(
                            'username'
                          )}
                        />
                      </div>
                    </div>
                    <div className={styles.newPasswordFormSeparator}>
                      or
                    </div>
                    <div id="password_email_input">
                      <div className="col-lg-12">
                        <input
                          className={styles.formInput}
                          id="password_email"
                          name="email"
                          placeholder="Email address"
                          type="email"
                          value={email}
                          onChange={this.handleChange(
                            'email'
                          )}
                        />
                      </div>
                    </div>
                    <div className={styles.formGroup}>
                      <div className={styles.formSubmit}>
                        <button
                          className={styles.actionButton}
                          id="password_submit_action"
                          name="button"
                          type="submit"
                        >
                          Reset password
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <Link
                  className={styles.nakednewsFormLink}
                  to="/account/login"
                >
                  &lt;&lt; Back to login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPasswordPage;
